export const COLOR = {
    待审核: '#FFC300',
    确认发货: '#43B402',
    拒绝发货: '#FF0000'
}

export const DefaultActions = [
    {
        text: '不变更',
        id: null
    },
    {
        text: '重置工单',
        id: null,
        reAssign: true
    }
]
